<div class="icon-picker">
  <button type="button" class="icon-picker__trigger d-flex align-items-center gap-2" (click)="openPicker()">
    @if (value() && !isUnknown()) {
      <span class="icon-picker__preview">
        <fa-icon [icon]="['fas', value()]" [fixedWidth]="true"></fa-icon>
      </span>
    }
    @if (value()) {
      <code class="icon-picker__name">{{ value() }}</code>
    } @else {
      <span class="icon-picker__placeholder" i18n="@@components.icon_picker.none">No icon selected</span>
    }
  </button>

  @if (isUnknown()) {
    <p class="icon-picker__warning" i18n="@@components.icon_picker.unknown">This icon name isn't registered — click to choose one.</p>
  }
</div>
